import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials so the session_token httpOnly cookie is sent/set cross-site.
const client = axios.create({ baseURL: API, withCredentials: true });

export default client;
